module.exports = "/_next/static/images/70cd42767515e5bc3f27431247a872ef-mother-and-daugther@0.5x.jpg";